import { Point, Rectangle, Vector } from "../../../../domain/drawing";
import { AbstractStandardTransformer } from "./AbstractStandardTransformer";

export class StandardTransformer extends AbstractStandardTransformer {
  protected resizeToTop(source: Rectangle, pointer: Point): Rectangle {
    const cloned = source.clone();
    const height = cloned.bottomRight.y - pointer.y;
    cloned.size.height = Math.max(height, 10);
    cloned.topLeft.y = pointer.y - (cloned.size.height - height);
    return cloned;
  }

  protected resizeToLeft(source: Rectangle, pointer: Point) {
    const cloned = source.clone();
    const width = cloned.bottomRight.x - pointer.x;
    cloned.size.width = Math.max(width, 10);
    cloned.topLeft.x = pointer.x - (cloned.size.width - width);
    return cloned;
  }

  protected resizeToRight(source: Rectangle, pointer: Point) {
    const cloned = source.clone();
    const width = pointer.x - cloned.x;
    cloned.size.width = Math.max(width, 10);
    return cloned;
  }

  protected resizeToBottom(source: Rectangle, pointer: Point) {
    const cloned = source.clone();
    const height = pointer.y - cloned.y;
    cloned.size.height = Math.max(height, 10);
    return cloned;
  }

  protected moveFrom(source: Vector, pointer: Point): Vector {
    return new Vector(pointer, source.to);
  }

  protected moveTo(source: Vector, pointer: Point): Vector {
    return new Vector(source.from, pointer);
  }
}
